<template>
    <div>
        <!-- Begin Page Content -->
        <div class="Medication-section">
            <div class="row">
                <div class="col-md-7 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3 text-center d-flex justify-content-center align-items-center">
                            <div class="text-center w-100">
                                <h2>Analyze Your Medication</h2>
                                <ul class="mb-0 d-flex mt-3 Upload-Prescription justify-content-between">
                                    <li class="text-left">
                                        <router-link to="/upload-prescription" class="d-flex align-items-center">
                                            <span class="icon"><i class="icon icon-upload-prescription"></i></span>
                                            <h6 class="mb-0">Upload Prescription</h6>
                                        </router-link >
                                        <p class="mt-2">Supported files type: jpeg , jpg , png , pdf</p>
                                    </li>
                                    <li class="text-left">
                                        <router-link to="/add-prescription" class="d-flex align-items-center">
                                            <span class="icon"><i class="icon icon-manual-prescription"></i></span>
                                            <h6 class="mb-0">Add Manual Prescription</h6>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-12 mb-4 text-left valid-prescription">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3 text-left">
                            <h2>Guide for a valid prescription</h2>
                            <figure><img src="../../../../static/website/images/gini-prescription.svg" /></figure>
                            <h3>Note: Prescription should contain</h3>
                            <ul class="mb-0">
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Doctor Name and Signature
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Patient Name
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Date of Prescription
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Don't crop out any part of the image
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Avoid blurred image
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Include Details of doctor and patient + clinic visit date
                                </li>
                                <li class="d-flex align-items-center">
                                    <i class="icon icon-check"></i>
                                    Medicines will be dispensed as per prescription
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "prescription-main",
        data() {
            return {};
        },
        created(){
           this.pageName('Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-main.vue